import { Pipe, PipeTransform } from '@angular/core';
import { VEHICLE_HISTORIC_TYPE_LABELS, VehicleHistoricType } from '@core/models';

@Pipe({ name: 'historicTypeKey', standalone: true })
export class HistoricTypePipe implements PipeTransform {
  transform(code: VehicleHistoricType | number | null | undefined): string {
    if (code === null || code === undefined) {
      return '';
    }

    return VEHICLE_HISTORIC_TYPE_LABELS[code as VehicleHistoricType] ?? '';
  }
}
